var _defs, _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgNounHiddenEye7187672Black(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1079.9 876",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill-rule:evenodd;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m857.3,231.6c121.9,84.9,200.9,188.1,206.4,195.4l16.2,21.5-16.1,21.5c-9.5,12.7-235.8,310.9-523.9,310.9-67.5,0-131.6-16.4-190.4-41.6l55.3-55.3c42.9,15.7,88.3,25.3,135.1,25.3,210.9,0,393.3-194.6,449.1-260.6-30-35-96.2-106.4-183.6-165.3l51.9-51.8Zm-62.4-39.4c-75-42.2-161.7-73.1-254.9-73.1C252,119.1,25.7,414.4,16.2,427L0,448.4l16.1,21.5c6.4,8.5,110.6,146,265.8,235.2l52.9-52.9c-116.9-62.8-207.4-160.6-243.9-203.7,55.9-65.5,238.2-258,449.1-258,71.8,0,140.4,22.4,201.8,54.6l53.1-52.9Zm-378.2,378.2c-30.4-31.1-49.1-73.6-49.1-120.4,0-95.1,77.3-172.4,172.4-172.4,46.8,0,89.3,18.7,120.4,49.1l-243.7,243.7Zm61.4,40.5c19.2,7.4,40.1,11.5,61.9,11.5,95.1,0,172.4-77.3,172.4-172.4,0-21.8-4.1-42.7-11.5-61.9l-222.8,222.8Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m886.9,0l50.9,50.9L112.7,876l-50.9-50.9L886.9,0Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNounHiddenEye7187672Black);
export default __webpack_public_path__ + "static/media/noun-hidden-eye-718767-2-black.aecc79a0a335e31e11d2a5a8630ecee0.svg";
export { ForwardRef as ReactComponent };